import React, { useContext, useEffect, useState, useCallback } from "react";
import debounce from "lodash.debounce";
import { useParams } from "react-router-dom";
import callAPI from "../../../../../../api/apiCaller";
import Icon from "../../../../../../common/Icon";
import Loading from "../../../../../../common/Loading";
import Table from "../../../../../../common/Table";
import { formatDateForParticipantDashboardActive } from "../../../../../../common/utils";
import { Context } from "../../../../../../Store";
import MeetingsConductedChart from "./MeetingsConductedChart";
import {
  ActiveUsers,
  Applicants,
  Avatar,
  AvatarInfo,
  AverageMeetings,
  BottomInfo,
  Box,
  BoxBottom,
  BoxDescription,
  Boxes,
  BoxInner,
  BoxTitle,
  BoxTop,
  ChartsLoader,
  DashboardBottomRow,
  DashboardInnerContainer,
  DashboardOuterContainer,
  DashboardUpperRow,
  Description,
  DescriptionTitle,
  DescriptionValue,
  Download,
  Dropdown,
  FollowLink,
  FormattedDate,
  Graph,
  IconContainer,
  IconWrapper,
  Image,
  ImageWrapper,
  Info,
  InfoLeft,
  Invite,
  Invited,
  MatchedBox,
  MeetingsConducted,
  MostActiveUsers,
  Name,
  Number,
  Pending,
  Statistics,
  StatisticsLoader,
  TableContainer,
  TableContainer2,
  User,
  Users,
  UserTag,
  ViewMoreContainer,
  ViewMoreText,
  NullStateContainer,
  NullStateText,
  NoMentorFound,
} from "./styles";
import ApplicationModal from "../modals/ApplicationModal";
import InviteModal from "./Invitemodal";
import AverageMeetingCharts from "./AverageMeetingCharts";
import ActiveUserCharts from "./ActiveUserCharts";
import MatchChart from "./MatchChart";
import { getUserInfo } from "../../../../../../Store/User/accessors";
import TextInput from "../../../../../../common/TextInput";
import moment from "moment-timezone";
import { ExportCSV } from "../../../../../../common/utils";

const ProfileDashboard = ({
  setSwitchToParticipants,
  setJoinAs,
  programType,
}) => {
  const params = useParams();
  const { state, dispatch } = useContext(Context);
  const [programStatics, setProgramStatics] = useState(null);
  const [loading, setLoading] = useState(true);
  const [applicationModal, setApplicationModal] = useState(null);
  const [isOpenApplicationModal, setIsOpenApplicationModal] = useState(false);
  const [inviteModal, setInviteModal] = useState(false);
  const [averageMentorMeetings, setAverageMentorMeetings] = useState([]);
  const [averageMentorMeetingsLoader, setAverageMentorMeetingsLoader] =
    useState(true);
  const [activeUsers, setActiveUsers] = useState([]);
  const [activeUsersLoader, setActiveUsersLoader] = useState(true);
  const [meetingsConducted, setMeetingsConducted] = useState([]);
  const [meetingsConductedLoader, setMeetingsConductedLoader] = useState(true);
  const [programMentor, setProgramMentor] = useState("");
  const [mentorResults, setMentorResults] = useState([]);
  const [noMentorFound, setNoMentorFound] = useState(false);
  const [matchLoader, setMatchLoader] = useState(true);
  const [matchedData, setMatchedData] = useState(null);
  const debouncedGetMentors = useCallback(
    debounce((input) => {
      if (!input.trim()) {
        setNoMentorFound(false);
        setMentorResults([]);
        return;
      }

      callAPI(dispatch, "getSearchMentorProgramParticipants", {
        id: params.selectedProgram,
        search: input,
        status: "active",
      }).then((response) => {
        const mentors = response.data?.active?.mentors || [];
        setMentorResults(response.data.active.mentors);
        if (input === "") {
        } else {
          setNoMentorFound(mentors.length === 0);
        }
      });
    }, 500),
    [dispatch, params.selectedProgram]
  );
  useEffect(() => {
    debouncedGetMentors(programMentor);
    return () => {
      debouncedGetMentors.cancel();
    };
  }, [programMentor, debouncedGetMentors]);

  const [programStaticsApplications, setProgramStaticsApplications] =
    useState(null);
  const [totalParticipant, setTotalParticipant] = React.useState("");
  const [subscription, setSubscription] = React.useState("");

  const slicedApplications = programStaticsApplications?.slice(0, 4);

  const programInformation = () => {
    callAPI(dispatch, "getStatisticsOpenNetworking", {
      programId: params.selectedProgram,
    })
      .then((info) => {
        setSubscription(info?.data?.statisticsCounts?.subscription);
        setTotalParticipant(info?.data?.statisticsCounts?.total);
        setProgramStatics(info.data);
        setProgramStaticsApplications(info.data.applicants);
      })
      .finally(() => setLoading(false));
  };

  const getMatchedData = () => {
    callAPI(dispatch, "getMatchedStatisticsOpenNetworking", {
      programId: params.selectedProgram,
    })
      .then((response) => {
        setMatchedData(response?.data);
      })
      .finally(() => setMatchLoader(false));
  };

  const getAverageMentorMeetings = () => {
    setAverageMentorMeetingsLoader(true);
    callAPI(dispatch, "getAverageMentorMeetings", {
      programId: params.selectedProgram,
      userId: mentorResults?.[0]?.participant?.id || null,
    })
      .then((response) => {
        const data = response?.data || {};
        const chartData = Object.keys(data).map((day) => ({
          name: day?.slice(0, 3)?.toUpperCase(),
          ...(data[day] || {}),
        }));
        setAverageMentorMeetings(chartData);
      })
      .finally(() => setAverageMentorMeetingsLoader(false));
  };

  useEffect(() => {
    getAverageMentorMeetings();
  }, [mentorResults]);

  const getActiveUserTrends = () => {
    callAPI(dispatch, "getActiveUserTrends", {
      programId: params.selectedProgram,
      userId: null,
    })
      .then((response) => {
        setActiveUsers(response.data);
      })
      .finally(() => setActiveUsersLoader(false));
  };
  const getMeetingConductedStatistics = () => {
    callAPI(dispatch, "getMeetingConductedStatistics", {
      programId: params.selectedProgram,
    })
      .then((response) => {
        setMeetingsConducted(response.data);
      })
      .finally(() => setMeetingsConductedLoader(false));
  };

  useEffect(() => {
    programInformation();
    getAverageMentorMeetings();
    getActiveUserTrends();
    getMeetingConductedStatistics();
    getMatchedData();
  }, []);

  const formatDateShort = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    });
  };

  const closeModal = (refresh = false, status = "") => {
    setInviteModal(false);
    if (refresh) {
      programInformation();
      getMatchedData();
    }
  };
  const resendInvite = (id) => {
    callAPI(dispatch, "resendInvite", { id: id }).then(() => {});
  };
  const recallAPIs = () => {
    programInformation();
    getMatchedData();
    getAverageMentorMeetings();
    getActiveUserTrends();
    getMeetingConductedStatistics();
  };

  const getCurrentDateHandler = () => {
    const userTimeZone = moment.tz.guess();
    const currentDate = moment.tz(userTimeZone).format("MMMM D, YYYY");
    return `Updated: ${currentDate}`;
  };

  //
  const exportDataHandler = () => {
    const labels = ["Month", "Count"];
    const dataKeys = ["month", "count"];

    const exportData = activeUsers?.monthly?.map((obj) => {
      return {
        month: obj?.name,
        count: obj?.count === 0 ? "0" : obj?.count,
      };
    });

    ExportCSV({
      labels,
      dataKeys,
      tableData: exportData,
      fileName: `Export_Users`,
    });
  };
  //

  return (
    <>
      {isOpenApplicationModal && applicationModal && (
        <ApplicationModal
          {...{
            applicationModal,
            setApplicationModal,
            setIsOpenApplicationModal,
            recallAPIs,
          }}
        />
      )}
      <DashboardOuterContainer>
        <DashboardInnerContainer>
          <DashboardUpperRow>
            <Boxes>
              <Box>
                <Info>
                  <InfoLeft>
                    <IconWrapper>
                      <Icon type="mentors" />
                    </IconWrapper>
                    <Description>
                      <DescriptionTitle>Mentors</DescriptionTitle>
                      <DescriptionValue>
                        {!loading ? (
                          programStatics?.statisticsCounts?.mentors
                        ) : (
                          <StatisticsLoader>
                            <Loading isLoading={loading} loadingItem="" />
                          </StatisticsLoader>
                        )}
                      </DescriptionValue>
                    </Description>
                  </InfoLeft>
                  <FollowLink
                    onClick={() => {
                      setSwitchToParticipants("mentors");
                      setJoinAs("mentor");
                    }}
                  >
                    <Icon type="followLink" />
                  </FollowLink>
                </Info>
                <BoxBottom>
                  <BottomInfo>
                    {/* Updated:{" "}
                    {formatDateForParticipantDashboard(
                      programStatics?.statisticsCounts?.mentorsLatestUpdated
                        ? programStatics?.statisticsCounts?.mentorsLatestUpdated
                        : programStatics?.statisticsCounts?.active_since
                    )} */}
                    {getCurrentDateHandler()}
                  </BottomInfo>
                </BoxBottom>
              </Box>

              <Box>
                <Info>
                  <InfoLeft>
                    <IconWrapper>
                      <Icon type="groups" />
                    </IconWrapper>
                    <Description>
                      <DescriptionTitle>Mentees</DescriptionTitle>
                      <DescriptionValue>
                        {!loading ? (
                          programStatics?.statisticsCounts?.mentees
                        ) : (
                          <StatisticsLoader>
                            <Loading isLoading={loading} loadingItem="" />
                          </StatisticsLoader>
                        )}
                      </DescriptionValue>
                    </Description>
                  </InfoLeft>
                  <FollowLink
                    onClick={() => {
                      setSwitchToParticipants("mentors");
                      setJoinAs("mentee");
                    }}
                  >
                    <Icon type="followLink" />
                  </FollowLink>
                </Info>
                <BoxBottom>
                  <BottomInfo>
                    {/* Updated:{" "}
                    {formatDateForParticipantDashboard(
                      programStatics?.statisticsCounts?.menteesLatestUpdated
                        ? programStatics?.statisticsCounts?.menteesLatestUpdated
                        : programStatics?.statisticsCounts?.active_since
                    )} */}
                    {getCurrentDateHandler()}
                  </BottomInfo>
                </BoxBottom>
              </Box>

              <Box>
                <Info>
                  <InfoLeft>
                    <IconWrapper>
                      <Icon type="groupAdd" />
                    </IconWrapper>
                    <Description>
                      <DescriptionTitle>Total</DescriptionTitle>
                      <DescriptionValue>
                        {!loading ? (
                          programStatics?.statisticsCounts?.total
                        ) : (
                          <StatisticsLoader>
                            <Loading isLoading={loading} loadingItem="" />
                          </StatisticsLoader>
                        )}
                      </DescriptionValue>
                    </Description>
                  </InfoLeft>
                  {programType === "1_1_NETWORK" && (
                    <FollowLink
                      onClick={() => {
                        setSwitchToParticipants("active");
                      }}
                    >
                      <Icon type="followLink" />
                    </FollowLink>
                  )}
                </Info>
                <BoxBottom>
                  <BottomInfo>
                    {/* Updated:{" "}
                    {formatDateForParticipantDashboard(
                      programStatics?.statisticsCounts?.totalLatestUpdated
                        ? programStatics?.statisticsCounts?.totalLatestUpdated
                        : programStatics?.statisticsCounts?.active_since
                    )} */}
                    {getCurrentDateHandler()}
                  </BottomInfo>
                </BoxBottom>
              </Box>

              <Box>
                <Info>
                  <InfoLeft>
                    <IconWrapper>
                      <Icon type="event" />
                    </IconWrapper>
                    <Description>
                      <DescriptionTitle>Active Since</DescriptionTitle>
                      <DescriptionValue textSize={"28px"}>
                        {!loading ? (
                          formatDateForParticipantDashboardActive(
                            programStatics?.statisticsCounts?.active_since
                          )
                        ) : (
                          <StatisticsLoader>
                            <Loading isLoading={loading} loadingItem="" />
                          </StatisticsLoader>
                        )}
                      </DescriptionValue>
                    </Description>
                  </InfoLeft>
                </Info>
              </Box>
            </Boxes>
          </DashboardUpperRow>
          <DashboardBottomRow>
            <Statistics>
              <MeetingsConducted>
                <BoxTop>
                  <BoxTitle>Meetings conducted</BoxTitle>
                  <Dropdown></Dropdown>
                </BoxTop>
                <Graph>
                  {!meetingsConductedLoader ? (
                    <MeetingsConductedChart data={meetingsConducted} />
                  ) : (
                    <ChartsLoader>
                      <Loading isLoading={loading} loadingItem="" />
                    </ChartsLoader>
                  )}
                </Graph>
              </MeetingsConducted>

              <AverageMeetings>
                <BoxTop>
                  <BoxTitle>Average number of meeting for Mentors</BoxTitle>
                  <TextInput
                    smallWidth={true}
                    value={programMentor}
                    setValue={setProgramMentor}
                    placeholder="Search Mentor"
                  />
                </BoxTop>
                {!averageMentorMeetingsLoader ? (
                  <Graph>
                    {noMentorFound ? (
                      <NoMentorFound>
                        No record found for this mentor
                      </NoMentorFound>
                    ) : (
                      <AverageMeetingCharts
                        data={averageMentorMeetings}
                        marginTop={true}
                      />
                    )}
                  </Graph>
                ) : (
                  <ChartsLoader>
                    <Loading isLoading={loading} loadingItem="" />
                  </ChartsLoader>
                )}
              </AverageMeetings>

              <MostActiveUsers>
                <BoxTop>
                  <BoxTitle>Most Active Mentors</BoxTitle>
                </BoxTop>
                {loading ? (
                  <ChartsLoader>
                    <Loading isLoading={loading} loadingItem="" />
                  </ChartsLoader>
                ) : programStatics?.mostActiveUsers &&
                  programStatics?.mostActiveUsers?.length === 0 ? (
                  <NullStateContainer>
                    <NullStateText>
                      There are no active mentors at this time.
                    </NullStateText>
                  </NullStateContainer>
                ) : (
                  <Users>
                    {(() => {
                      const programStaticsData =
                        programStatics?.mostActiveUsers?.slice(0, 6);

                      return programStaticsData?.map((user, index) => (
                        <User key={index}>
                          <ImageWrapper>
                            <Image
                              src={
                                user.image
                                  ? user.image
                                  : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
                              }
                              alt="Person"
                            />
                          </ImageWrapper>
                          <UserTag>
                            <Number>
                              {index + 1}
                              {index + 1 === 1
                                ? "st"
                                : index + 1 === 2
                                ? "nd"
                                : index + 1 === 3
                                ? "rd"
                                : "th"}
                            </Number>
                            <Name>{user.name ?? ""}</Name>
                          </UserTag>
                        </User>
                      ));
                    })()}
                  </Users>
                )}
              </MostActiveUsers>

              <Applicants>
                <BoxTop>
                  <BoxTitle>Applicants</BoxTitle>
                  <Invite
                    style={{
                      cursor:
                        !subscription ||
                        (subscription?.plan === "Basic" &&
                          totalParticipant + 1 > 100) ||
                        (subscription?.plan === "Pro" &&
                          totalParticipant + 1 > 250)
                          ? "not-allowed"
                          : "pointer",
                    }}
                    disabled={
                      !subscription ||
                      (subscription?.plan === "Basic" &&
                        totalParticipant + 1 > 100) ||
                      (subscription?.plan === "Pro" &&
                        totalParticipant + 1 > 250)
                    }
                    onClick={() => setInviteModal(!inviteModal)}
                  >
                    Invite
                  </Invite>
                  {inviteModal && <InviteModal closeModal={closeModal} />}
                </BoxTop>
                <TableContainer isDashboard={true}>
                  {loading ? (
                    <ChartsLoader>
                      <Loading isLoading={loading} loadingItem="" />
                    </ChartsLoader>
                  ) : slicedApplications && slicedApplications.length === 0 ? (
                    <NullStateContainer>
                      <NullStateText>
                        There are no applicants at this time.
                      </NullStateText>
                    </NullStateContainer>
                  ) : (
                    <>
                      <TableContainer2 isDashboard={true}>
                        <Table
                          minWidth="400px"
                          meetingsDashboard={true}
                          isApplicants={true}
                          columns={[
                            {
                              width: "40%",
                              key: "name",
                              title: "Name",
                              sortable: true,
                              sortValueFn: (row) => {
                                const isPending =
                                  row.applicationStatus === "Pending";
                                if (isPending) {
                                  const fullName = `${row.firstName ?? ""} ${
                                    row.lastName ?? ""
                                  }`.trim();
                                  return fullName.toLowerCase();
                                } else {
                                  return (row.email ?? "").toLowerCase();
                                }
                              },
                              render: ({ row }) => {
                                return (
                                  <>
                                    {row.applicationStatus === "Pending" ? (
                                      <AvatarInfo>
                                        <Info>
                                          {
                                            <Avatar
                                              leftSpace={1}
                                              src={
                                                row?.image
                                                  ? row?.image
                                                  : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
                                              }
                                            />
                                          }
                                        </Info>
                                        <p style={{ minWidth: "fit-content" }}>
                                          {row?.firstName +
                                            " " +
                                            (row?.lastName
                                              ? row.lastName.charAt(0) + "."
                                              : "")}
                                        </p>
                                      </AvatarInfo>
                                    ) : (
                                      <p className="text-wrap">{row?.email}</p>
                                    )}
                                  </>
                                );
                              },
                            },
                            {
                              width: "20%",
                              key: "status",
                              title: "Status",
                              sortable: true,
                              sortValueFn: (row) =>
                                row?.applicationStatus ?? "",
                              render: ({ row }) => {
                                const status = row?.applicationStatus;
                                return status === "Invited" ? (
                                  <Invited>{status}</Invited>
                                ) : (
                                  <Pending>{status}</Pending>
                                );
                              },
                            },

                            {
                              width: "40%",
                              key: "date",
                              title: "Date",
                              sortValueFn: (row) => {
                                const status = row?.applicationStatus;
                                const date =
                                  status === "Invited"
                                    ? row.createdAt
                                    : row.dateApplied;
                                return date ? new Date(date).getTime() : null;
                              },
                              render: ({ row }) => {
                                const status = row?.applicationStatus;
                                return status === "Invited" ? (
                                  <div style={{ minWidth: "max-content" }}>
                                    <FormattedDate>
                                      {formatDateShort(row.createdAt)}
                                    </FormattedDate>
                                    <IconContainer
                                      onClick={() => {
                                        resendInvite(row.id);
                                      }}
                                    >
                                      <Icon type="reload-icon" />
                                    </IconContainer>
                                  </div>
                                ) : (
                                  <div style={{ minWidth: "max-content" }}>
                                    <FormattedDate>
                                      {/* {formatDateShort(row.createdAt)} */}
                                      {formatDateShort(row.dateApplied)}
                                    </FormattedDate>
                                    <IconContainer
                                      onClick={() => {
                                        setApplicationModal(row);
                                        setIsOpenApplicationModal(true);
                                      }}
                                    >
                                      <Icon type="followLink" />
                                    </IconContainer>
                                  </div>
                                );
                              },
                            },
                          ]}
                          rows={slicedApplications}
                        />
                      </TableContainer2>
                      <ViewMoreContainer>
                        <ViewMoreText
                          onClick={() => {
                            setSwitchToParticipants("");
                          }}
                        >
                          View More
                        </ViewMoreText>
                      </ViewMoreContainer>
                    </>
                  )}
                </TableContainer>
              </Applicants>

              <ActiveUsers>
                <BoxTop>
                  <BoxInner>
                    <BoxTitle>Active Users (Trend)</BoxTitle>
                    <BoxDescription>Line charts | Last 90 days</BoxDescription>
                  </BoxInner>
                  <Download onClick={exportDataHandler}>
                    <Icon type="downloadIcon" />
                    Download
                  </Download>
                </BoxTop>
                {activeUsersLoader ? (
                  <ChartsLoader>
                    <Loading isLoading={loading} loadingItem="" />
                  </ChartsLoader>
                ) : (
                  <Graph>
                    {/* <Image src={ActiveUser} alt="" /> */}
                    <ActiveUserCharts data={activeUsers} />
                  </Graph>
                )}
              </ActiveUsers>

              {programType !== "OPEN_NETWORK" && (
                <MatchedBox>
                  <BoxTop>
                    <BoxTitle>Mentee Matched Status</BoxTitle>
                  </BoxTop>
                  <Graph>
                    {!matchLoader ? (
                      <NullStateContainer>
                        {matchedData &&
                        matchedData?.length > 0 &&
                        matchedData[0]?.matchedMenteesCount > 0 &&
                        matchedData[0]?.unmatchedMenteesCount > 0 ? (
                          <MatchChart data={matchedData} />
                        ) : (
                          <NullStateText>
                            There are no matches at this time.
                          </NullStateText>
                        )}
                      </NullStateContainer>
                    ) : (
                      <ChartsLoader>
                        <Loading isLoading={matchLoader} loadingItem="" />
                      </ChartsLoader>
                    )}
                  </Graph>
                </MatchedBox>
              )}
            </Statistics>
          </DashboardBottomRow>
        </DashboardInnerContainer>
      </DashboardOuterContainer>
    </>
  );
};

export default ProfileDashboard;
